import { adminClient as apolloClient } from '@/store/apollo';

import MemberTagsGql from '@/extensions/restrictedArea/store/graphql/queries/MemberTags.gql';
import BulkAddMemberTagsGql from '@/extensions/restrictedArea/store/graphql/mutations/BulkAddMemberTags.gql';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: MemberTagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_RSTRCT_MemberTags))
                .catch(err => reject(err));
        }),

    bulkAddTags: (cmsId, emails, tags) =>
        new Promise((resolve, reject) => {
            if (!cmsId || !emails || !tags) {
                throw new Error('required argument is missing');
            }

            // Convert tag objects to the format expected by the mutation
            var formattedTags = tags.map(function(tag) {
                return {
                    id: String(tag.id),
                    name: tag.name
                };
            });

            apolloClient
                .mutate({
                    mutation: BulkAddMemberTagsGql,
                    variables: {
                        cms_id: parseInt(cmsId),
                        emails: emails,
                        tags: formattedTags
                    }
                })
                .then(({ data }) => resolve(data.EX_RSTRCT_BulkAddMemberTags))
                .catch(err => reject(err));
        })
};
